export default __webpack_public_path__ + "static/mobile-projects-df6b0aa1e66881279fe1a0bff9c893da.png";